import * as crowdAddCoupon from '../services/crowdAdd';

export default {
  namespace: 'crowdAddCoupon',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
    memberDetail: {},
    manualOperationCouponChooseIdData: [],
    manualOperationCouponChooseData: [],
    failureOperationCouponChooseIdData: [],
    failureOperationCouponChooseData: [],
  },

  effects: {
    //获取该会员详情
    *getMemberDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAddCoupon.getMemberDetail, values);
      yield put({
        type: 'save',
        payload: {
          memberDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getUserGroupList({ payload: { values } }, { call, put }) {
      const response = yield call(crowdAddCoupon.getUserGroupList, {
        ...values,
        status: 1,
      });
      yield put({
        type: 'save',
        payload: {
          userGroupList: response?.data,
        },
      });
    },

    //获取活动相关信息
    *getActivityInfo({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAddCoupon.getActivityInfo, values);
      yield put({
        type: 'save',
        payload: {
          activityInfo: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 清除数据
    *clearActivityInfo({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          activityInfo: [],
          manualOperationCouponChooseIdData: [],
          manualOperationCouponChooseData: [],
          failureOperationCouponChooseIdData: [],
          failureOperationCouponChooseData: [],
        },
      });
    },

    //新增活动人群
    *addActivityGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAddCoupon.addActivityGroup, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     ActivityInfo: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //更新活动人群
    *updateActivityGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAddCoupon.updateActivityGroup, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     ActivityInfo: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 获取微信模板
    *getWechatTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAddCoupon.getWechatTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          wechatTemplateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 获取短信模板消息
    *getSmsTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAddCoupon.getSmsTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          smsTemplateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 获取周期类型将月和天放进去
    *getCycleTypeList({ payload: { values }, callback }, { all, call, put }) {
      const [cycleTypeList, monthDayList, weekDayList] = yield all([
        call(crowdAddCoupon.getCycleTypeList, values),
        call(crowdAddCoupon.getMonthDayList, values),
        call(crowdAddCoupon.getWeekDayList, values),
      ]);

      yield put({
        type: 'save',
        payload: {
          cycleData: {
            cycleTypeList: cycleTypeList?.data,
            monthDayList: monthDayList?.data,
            weekDayList: weekDayList?.data,
          },
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
    *postManualOperation({ payload: { values }, callback }, { call }) {
      const response = yield call(
        crowdAddCoupon.postManualOperation,
        values,
        callback,
      );
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
    *getCouponDetail({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAddCoupon.getCouponDetail, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
    //调整会员优惠券信息列表
    *getManualOperationCoupon(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        crowdAddCoupon.getManualOperationCoupon,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          manualOperationCouponData: response.data.data,
          manualOperationPages: response.data.pages,
        },
      });
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
    *getFailureCoupon({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        crowdAddCoupon.getManualOperationCoupon,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          failureOperationCouponData: response.data.data,
          failureOperationPages: response.data.pages,
        },
      });
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
    *saveOperationCoupon({ payload: { values } }, { put }) {
      console.log('values', values);
      yield put({
        type: 'save',
        payload: {
          manualOperationCouponChooseIdData: values.chooseIdData,
          manualOperationCouponChooseData: values.chooseData,
        },
      });
    },
    *saveFailureCoupon({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          failureOperationCouponChooseIdData: values.chooseIdData,
          failureOperationCouponChooseData: values.chooseData,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        const pathnames = [
          '/marketing/crowd/registered_unpaid',
          '/marketing/crowd/key_recall',
          '/marketing/crowd/custom_crowd',
          '/marketing/crowd/assign_telephone',
          '/adjust/adjust_list/patch_coupon',
        ];
        if (pathnames.includes(props.pathname)) {
          dispatch({
            type: 'clearActivityInfo',
            payload: {
              values: {},
            },
          });
        }
      });
    },
  },
};
